export enum CompanyEnums{
  altosSoftware = 1,
}